// extracted by mini-css-extract-plugin
export var active = "z_bd";
export var arrow = "z_9";
export var icon = "z_bq";
export var link = "z_bx";
export var links = "z_bX";
export var otherLink = "z_ch";
export var title = "z_h";